import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { useWindowSize } from 'hooks/useWindowSize'
import ArrowWithLineIcon from 'components/Icons/ArrowWithLineIcon'
import SideMenuIcon from 'components/Icons/SideMenuIcon'
import { useSelector } from 'react-redux'
import { useRole } from 'hooks/useRole'
import DefaultImage from 'components/Common/DefaultImage'
import webIcon from 'assets/images/web-icon.svg'
import { useConfig } from 'config/ConfigContext'

const SideMenu = ({
	toggleSideMenu,
	setToggleSideMenu,
	menuLinks,
	isProject,
	data
}) => {
	const config = useConfig()
	const organization = useSelector(state => state.organization)
	const [width] = useWindowSize()
	const isAdmin = useRole('Admin')
	const location = useLocation()
	const { role, name } = useSelector(state => state.user)
	const isActive = (path, nested) => {
		let match = false
		if (nested) {
			match = location.pathname.includes(path)
		} else {
			match = location.pathname === path
		}
		return match ? 'active' : ''
	}

	const openInNewTab = url => {
		const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
		if (newWindow) newWindow.opener = null
	}

	return (
		<div
			style={{ height: width <= 1288 ? '100vh' : 'calc(100vh - 75px)' }}
			className={`w-[215px] pb-14 h-full bg-gray-300 xl:sticky xl:top-[70px] overflow-auto duration-100 fixed top-0 z-40 flex-shrink-0 mr-5 ${toggleSideMenu ? 'left-0' : '-left-[215px]'
				}`}>
			<Link
				to={'/dashboard'}
				className='flex items-center text-gray-400 text-sm font-medium gap-2 xl:hidden justify-center h-[53px] bg-white '>
				<span>
					<ArrowWithLineIcon width={10} height={9} color='currentColor' />
				</span>
				Back to Home
			</Link>
			<div className=' px-4 mb-3 '>
				<div className='flex items-center py-4 border-b border-gray-200 border-solid'>
					{isProject && !isAdmin ? (
						<div className='flex flex-col'>
							<Link to={'/dashboard/projects'}>
								<div>
									<DefaultImage
										className='mx-auto'
										src={data?.logo}
										bgColor={data?.background_color}
										mainColor={data?.foreground_color}
										size={48}
										type='project'
										iconSize={30}
									/>
								</div>
								<div className='mx-auto'>
									<h1 className='text-gray-700 text-base font-medium mt-2'>
										{data?.name}
									</h1>
									<span className='text-[10px] flex mt-1 font-light text-gray-700 text-opacity-40'>
										Change {config?.use_case_name}
									</span>
								</div>
							</Link>
							{data?.url && (
								<button
									onClick={() => openInNewTab(data?.url)}
									className='ls:px-3 px-3 flex w-full justify-center items-center border border-solid hover:bg-primaryBlue whitespace-nowrap hover:bg-opacity-5 duration-300 border-primaryBlue rounded-[10px] gap-2 text-sm font-medium text-primaryBlue h-11 mt-5'>
									<img className='w-[24px] h-[24px]' src={webIcon} alt='' />
									Website
								</button>
							)}
						</div>
					) : (
						<div>
							<div className='flex items-center gap-[6px]'>
								<DefaultImage
									className='w-[26px] h-[26px]'
									src={organization?.logo}
									name={organization?.name}
									type='organization'
									size={26}
								/>
								<h1 className='text-gray-700 text-base font-medium'>
									{isAdmin ? name : organization?.name}
								</h1>
							</div>
							<span className='text-[10px] flex -mt-0.5 font-light text-gray-700 text-opacity-40'>
								{isAdmin ? 'Admin' : ''}
							</span>
						</div>
					)}
				</div>
			</div>
			<div style={{ height: 'calc(100vh - 150px)' }} className='flex flex-col'>
				{menuLinks.length &&
					menuLinks.map(({ groupTitle, links, access }) =>
						access.includes('All') || access.includes(role?.name) ? (
							<div className='mb-12 last:mb-0' key={groupTitle}>
								{/* <h3 className='mb-2 px-5 text-[10px] font-semibold text-opacity-20 text-gray-700'>
								{groupTitle}
							</h3> */}
								<div className=''>
									{links.length &&
										links.map(
											({ title, path, defaultIcon, nested, access }) =>
												access.includes(role?.name) && (
													<Link
														reloadDocument
														key={path}
														to={path}
														className={`px-5 flex relative items-center gap-3 h-12 ${isActive(path, nested)
															? 'text-primaryBlue'
															: 'text-gray-400'
															}`}>
														<span
															className={`w-[18px] -mt-0.5  flex justify-center`}>
															{defaultIcon}
														</span>
														<span>{title}</span>
														{isActive(path, nested) && (
															<i className='h-[30px] bg-primaryBlue absolute right-0 top-1/2 -translate-y-1/2 w-1 rounded-l'></i>
														)}
													</Link>
												)
										)}
								</div>
							</div>
						) : null
					)}
				{toggleSideMenu && (
					<div
						className='fixed xl:hidden top-0 left-[215px] w-full h-full bg-gray-700 bg-opacity-40'
						onClick={() => setToggleSideMenu(false)}>
						<button
							onClick={() => setToggleSideMenu(false)}
							className=' bg-gray-200 w-11 h-11 mt-4 ml-1.5 -rotate-90 flex items-center justify-center rounded-[10px]'>
							<SideMenuIcon />
						</button>
					</div>
				)}
				<div className='text-center text-gray-350 text-sm mt-auto'>
					NPIX Academy V.2
				</div>
			</div>
		</div>
	)
}

SideMenu.propTypes = {
	toggleSideMenu: PropTypes.bool.isRequired,
	setToggleSideMenu: PropTypes.func.isRequired,
	menuLinks: PropTypes.array.isRequired,
	isProject: PropTypes.bool.isRequired
}

SideMenu.defaultProps = {
	toggleSideMenu: false,
	isProject: true,
	setToggleSideMenu: () => { },
	menuLinks: []
}

export default SideMenu
